import { Pipe, PipeTransform } from 'angular-ts-decorators';
import { Country } from '../services/country';

export type CountryNameFilter = (input: string) => string;

interface ICountryName {
  transform: CountryNameFilter;
}

/**
 * Filter that returns the local country name
 * when provided the two letter country ISO code
 * @param {string} input two letter country ISO code
 * @return {string} full local country name
 */
@Pipe({ name: 'countryName' })
export class CountryNamePipe implements PipeTransform, ICountryName {
  constructor(
    private $translate: ng.translate.ITranslateService,
    private country: Country,
  ) {
    'ngInject';
  }
  public transform(input: string): string {
    if (angular.isString(input)) {
      let countryObj = this.country.getCountryByCode(input.toUpperCase());
      if (countryObj) {
        return countryObj.name;
      } else {
        return this.$translate.instant('core.unknown');
      }
    } else {
      return this.$translate.instant('core.unknown');
    }
  }
}
